import { render, staticRenderFns } from "./RocketLeagueRecap2022.vue?vue&type=template&id=31b269f0&scoped=true&"
import script from "./RocketLeagueRecap2022.vue?vue&type=script&lang=js&"
export * from "./RocketLeagueRecap2022.vue?vue&type=script&lang=js&"
import style0 from "./RocketLeagueRecap2022.vue?vue&type=style&index=0&id=31b269f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b269f0",
  null
  
)

export default component.exports